import { AiSearchKeyType } from '../../keys';

const aiSearchKeys: AiSearchKeyType = {
  aiPoweredCLIPSearch: 'AI-Powered CLIP Search',
  aiPoweredSearch20: 'AI-Powered Search 2.0',
  aiPoweredSearch30: 'AI-Powered Search 3.0',
  aiPoweredSearch: 'AI-Powered Search',
  aiPoweredSearchDetect: 'AI-Powered Search (Detect)',
  bestMatchesForDetectedObjects: 'Best matches for {{count}} detected objects',
  bestMatch: 'Best match',
  moreMatches: 'More matches',
  showMoreMatches: 'Show more matches',
  hideMoreMatches: 'Hide more matches',
  closeMatches: 'Close matches',
  findAlternatives: 'Find alternatives',
  findSimilar: 'Find similar',
  findProducts: 'Find products',
  imageSearch: 'Image search',
  objectsFoundInTheSourceImage: 'Objects found in the source image',
  pleaseUploadASinglePhoto:
    'Please upload a single photo of your room, and our AI will detect the furniture pieces and find the most similar products from our 3D library.',
  pleaseUploadPhoto: 'Please upload a photo',
  search: 'Search',
  searchInImage: 'Search in image',
  sourceImage: 'Source image',
  sourceProduct: 'Source product',
  uploadAPhotoOfARoom:
    'Upload a photo of a room, and our AI will find furniture items for you.',
  uploadAPhotoOfYourFurnitureAndWellHelpYouFindMatchingItems:
    "Upload a photo of your furniture, and we'll help you find matching items."
};

export default aiSearchKeys;
